import { InjectionToken } from '@angular/core';

import {
  AMP_DEFAULT_CURRENCY,
  AMP_DEFAULT_LOCALE,
  AMP_DEFAULT_TIMEZONE,
} from './defaults';

export const AMP_LOCALE = new InjectionToken<string>('AMP_LOCALE', {
  factory: () => AMP_DEFAULT_LOCALE,
});

export const AMP_TIMEZONE = new InjectionToken<string>('AMP_TIMEZONE', {
  factory: () => AMP_DEFAULT_TIMEZONE,
});

export const AMP_CURRENCY = new InjectionToken<string>('AMP_CURRENCY', {
  factory: () => AMP_DEFAULT_CURRENCY,
});
